/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import WCCheckoutChangeBillingForm from './modules/WCCheckoutChangeBillingForm';
import LDTutorialModal from './modules/LDTutorialModal';
import LDGridMoreCourses from './modules/LDGridMoreCourses';
import APWTabsBlock from './modules/APWTabsBlock';

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener('DOMContentLoaded', () => {
    const myWCCheckoutChangeBillingForm = new WCCheckoutChangeBillingForm();
    const myLDTutorialModal = new LDTutorialModal();
    const myLDGridMoreCourses = new LDGridMoreCourses();
    const myAPWTabsBlock = new APWTabsBlock('jsApwTabsBlock');
});
